import * as React from 'react';

function SignatureBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g fill="#6C7680" fillRule="nonzero">
				<path d="M15.28 3.573l5.11 5.12-1.022 1.024-5.109-5.12zM5.063 13.813l5.11 5.12-1.022 1.024-5.11-5.12z" />
				<path d="M19.879 4.085a2.18 2.18 0 010 3.072l-5.11 5.12-1.02 1.024-6.33 6.344-3.832.77.766-3.842 6.33-6.345 6.13-6.144a2.166 2.166 0 013.066 0M20.9 3.06a3.607 3.607 0 00-5.109 0l-6.13 6.145-6.64 6.654L2 20.98l1.02 1.027 5.11-1.026 6.64-6.655 1.021-1.024 5.11-5.12a3.627 3.627 0 000-5.12z" />
			</g>
		</svg>
	);
}

export default SignatureBlockIcon;
